<h2 mat-dialog-title style="text-align:center; margin-bottom: 16px;">Create Data Offer</h2>
<mat-dialog-content>
  <div style="display: flex; flex-direction: column; gap: 20px;">
    <mat-form-field class="form-field" color="accent" id="form-field-id">
        <mat-label>Id</mat-label>
        <mat-icon matPrefix>fingerprint</mat-icon>
        <input [(ngModel)]="contractDefinition['@id']" [disabled]="editMode" matInput required>
    </mat-form-field>


        <mat-form-field color="accent" class="form-field form-field-policy" id="form-field-access-policy">
            <mat-label>Access policy</mat-label>
            <mat-icon matPrefix>policy</mat-icon>
            <mat-select [(ngModel)]="accessPolicy" required>
                <mat-option *ngFor="let policy of policies" [value]="policy">
                    
                    {{policy['@id']}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field color="accent" class="form-field form-field-policy" id="form-field-contract-policy">
            <mat-label>Contract policy</mat-label>
            <mat-icon matPrefix>policy</mat-icon>
            <mat-select [(ngModel)]="contractPolicy" required>
                <mat-option *ngFor="let policy of policies" [value]="policy">
                    
                    {{policy['@id']}}
                </mat-option>
            </mat-select>
        </mat-form-field>

                <mat-form-field color="accent" class="form-field form-field-assets" id="form-field-contract-assets">
                    <mat-label>Assets</mat-label>
                    <mat-icon matPrefix>inventory_2</mat-icon>
                    <mat-select [(ngModel)]="assets" multiple>
                        <mat-option *ngFor="let asset of availableAssets" [value]="asset">
                            {{asset.id}}
                        </mat-option>
          </mat-select>
        </mat-form-field>
    </div>

</mat-dialog-content>


<mat-dialog-actions>

    <button color="warn" mat-dialog-close mat-stroked-button>
        <mat-icon>cancel</mat-icon> Cancel
    </button>

    <button (click)="onSave()" *ngIf="editMode" color="accent" mat-flat-button>
        <mat-icon>save</mat-icon> Save
    </button>

    <button (click)="onSave()" *ngIf="!editMode" color="accent" mat-flat-button>
        <mat-icon>add_circle</mat-icon> Create
    </button>

</mat-dialog-actions>
